export const SR_indexOutOfBounds = "The index was outside the range of elements in the collection.";
export const SR_inputWasEmpty = "Collection was empty.";
export const SR_inputMustBeNonNegative = "The input must be non-negative.";
export const SR_inputSequenceEmpty = "The input sequence was empty.";
export const SR_inputSequenceTooLong = "The input sequence contains more than one element.";
export const SR_keyNotFoundAlt = "An index satisfying the predicate was not found in the collection.";
export const SR_differentLengths = "The collections had different lengths.";
export const SR_notEnoughElements = "The input sequence has an insufficient number of elements.";
